import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCompany, fetchCompanyMenuItems } from "apis/Service";



const setCompanyMenuItems = createAsyncThunk(
    'header/setCompanyMenuItems',
    async (arg, thunkAPI) => {
        try{
            const menuItems = await fetchCompanyMenuItems()
            return menuItems
        } catch (error) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

const setContractDate = createAsyncThunk(
    'header/setContractDate',
    async (corp_no, thunkAPI) => {

        // return null
        const state = thunkAPI.getState();

        const selectCompanyNo = corp_no;

        try{
            const resp = await fetchCompany(selectCompanyNo);

            if (resp.contractEndDate){
                return resp.contractEndDate
            }else if(resp.contractType === '종신 계약'){
                return '종신'
            }else{
                return '오류'
            }
        } catch (error) {
            return thunkAPI.rejectWithValue(error)
        }
    }
)

const setCompanyNo = createAsyncThunk(
    'header/setCompanyNo',
    async (corp_no, { getState, dispatch }) => {
        const state = getState();
        const newCompanyNo = corp_no ;
        // getContractDate를 dispatch로 호출
        await dispatch(setContractDate(newCompanyNo));
        return newCompanyNo;
    }
)

const initialState = {
    companyMenuItems: JSON.parse(localStorage.getItem('companyMenuItems')) || [],
    selectCompanyNo: JSON.parse(localStorage.getItem('selectCompanyNo')) || '',
    contractDate: localStorage.getItem('contractDate') ? JSON.parse(localStorage.getItem('contractDate')) : ''
};


export const headerSlice = createSlice({
    name: 'header',
    initialState,
    extraReducers: (null, (builder) => {
        builder
            .addCase(setCompanyMenuItems.pending, (state) => {
                state.companyMenuItems = []
            })
            .addCase(setCompanyMenuItems.fulfilled, (state, action) => {
                state.companyMenuItems = action.payload;
                localStorage.setItem('companyMenuItems', JSON.stringify(action.payload)); // 로컬 스토리지에 저장
            })
            .addCase(setCompanyMenuItems.rejected, (state) => {
                state.companyMenuItems = []
            })
            .addCase(setContractDate.fulfilled, (state, action) => {
                state.contractDate = action.payload;
                localStorage.setItem('contractDate', JSON.stringify(action.payload));
            })
            .addCase(setContractDate.rejected, (state) => {
                state.contractDate = ''
            })
            .addCase(setCompanyNo.pending, (state) => {
                state.selectCompanyNo = ''
            })
            .addCase(setCompanyNo.fulfilled, (state, action) => {
                state.selectCompanyNo = action.payload;
                localStorage.setItem('selectCompanyNo', JSON.stringify(action.payload));
            });
    })
});

export { setCompanyMenuItems, setContractDate, setCompanyNo };

export default headerSlice.reducer;
